module.exports = __webpack_public_path__ + "img/map-def.7f335b8e.png";